import { PlayerHome } from '@/modules/player/components/home';
import { withMotion } from '../hoc/with-motion';


const AnimatedPage = withMotion(PlayerHome);

export const roles: string[] = [];
export const path = '/player';
export const element = <AnimatedPage />